import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Panel, Eyebrow } from "@/components/mh/bits";

export const DeptCard = ({ d, i = 0 }) => {
  const pctLive = d.total ? (d.live / d.total) * 100 : 0;
  const pctDev = d.total ? (d.in_dev / d.total) * 100 : 0;
  return (
    <Link to={`/departments/${d.slug}`} data-testid={`dept-card-${d.slug}`} className="group block mh-rise" style={{ animationDelay: `${i * 60}ms` }}>
      <Panel cls="relative overflow-hidden p-5 h-full transition-[border-color,transform] duration-300 group-hover:-translate-y-0.5 group-hover:border-white/20">
        <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-[0.12] blur-2xl transition-opacity duration-300 group-hover:opacity-25" style={{ background: d.hex }} />
        <div className="flex items-start justify-between">
          <Eyebrow>{String(d.order).padStart(2, "0")} · {d.tagline}</Eyebrow>
          <ArrowUpRight className="w-4 h-4 text-muted-foreground transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
        <h3 className="font-display text-3xl mt-3" style={{ color: d.hex }}>{d.name}</h3>
        <p className="text-sm text-muted-foreground mt-1.5 line-clamp-2">{d.cluster_summary}</p>
        <div className="mt-5 h-1.5 rounded-full bg-white/[0.06] overflow-hidden flex">
          <div className="h-full transition-[width] duration-700" style={{ width: `${pctLive}%`, background: d.hex }} />
          <div className="h-full bg-white/20 transition-[width] duration-700" style={{ width: `${pctDev}%` }} />
        </div>
        <div className="grid grid-cols-3 gap-2 mt-4 font-mono text-[11px]">
          <div><div className="text-foreground text-base tabular-nums">{d.live}/{d.total}</div><div className="text-muted-foreground">live</div></div>
          <div><div className="text-foreground text-base tabular-nums">{d.runs_today.toLocaleString()}</div><div className="text-muted-foreground">runs today</div></div>
          <div><div className="text-base tabular-nums" style={{ color: d.pending_approvals ? "#FFB020" : undefined }}>{d.pending_approvals}</div><div className="text-muted-foreground">need you</div></div>
        </div>
      </Panel>
    </Link>
  );
};
